module.exports = __webpack_public_path__ + "static/media/icons-ic-calendar-time-off-accepted.0f673b67.svg";